import { Image, Stack, Text } from "@mantine/core";
import { Img } from "remotion";
import DefaultProfileImage from "../../../../images/video/DefaultProfileImage.jpg";
function Character(props: {
  name: string;
  imageUrl: string;
  isSpeaking: boolean;
  location: "left" | "right";
  characterId: string;
  disableCharacterHeadshots?: boolean;
  disableCharacterNames?: boolean;
}) {
  const {
    name,
    imageUrl,
    isSpeaking,
    location,
    characterId,
    disableCharacterHeadshots,
    disableCharacterNames,
  } = props;
  const hideAvatar =
    !characterId ||
    characterId.toLowerCase() === "narrator" ||
    disableCharacterHeadshots;

  return (
    <Stack
      style={{
        textAlign: "center",
        //width: "20%",
        //height: "40%",
        position: "absolute",
        [location]: 30,
        bottom: 30,
        zIndex: isSpeaking ? 10000 : undefined,
      }}
    >
      {!hideAvatar && (
        <Img
          pauseWhenLoading={false}
          style={{
            borderRadius: "50%",
            boxShadow: "0px 0px 12px 6px rgba(0,0,0,.5)",
            maxWidth: "100px",
            width: "100px",
            height: "100px",
            minWidth: "100px",
            minHeight: "100px",
            objectFit: "cover",
            // backgroundColor: `rgba(0,0,0,1)`,
            // display: "flex",
            // justifyContent: "center",
            // alignItems: "center",
          }}
          src={imageUrl || DefaultProfileImage}
          // nonce="placeholder"
          // onResize={() => {}}
          // onResizeCapture={() => {}}
        />
      )}
      {!disableCharacterNames && (
        <Text w={100} c="white" fw={600} h="lg" truncate="end">
          {name}
        </Text>
      )}
    </Stack>
  );
}

export default function TalkingCharacters(props: {
  characters: {
    left: {
      imageUrl: string;
      id: string;
      isSpeaking: boolean;
      name: string;
    };
    right: {
      imageUrl: string;
      id: string;
      isSpeaking: boolean;
      name: string;
    };
  };
  disableCharacterHeadshots?: boolean;
  disableCharacterNames?: boolean;
}) {
  const { characters, disableCharacterHeadshots, disableCharacterNames } =
    props;

  return (
    <>
      <Character
        name={characters.left.name}
        imageUrl={characters.left.imageUrl}
        isSpeaking={characters.left.isSpeaking}
        location="left"
        characterId={characters.left.id}
        disableCharacterHeadshots={disableCharacterHeadshots}
        disableCharacterNames={disableCharacterNames}
      />

      <Character
        name={characters.right.name}
        imageUrl={characters.right.imageUrl}
        isSpeaking={characters.right.isSpeaking}
        location="right"
        characterId={characters.right.id}
        disableCharacterHeadshots={disableCharacterHeadshots}
        disableCharacterNames={disableCharacterNames}
      />
    </>
  );
}
